enum DocumentTypeEnum {
    IMAGE = 1,
    FILE = 2,
}

export default DocumentTypeEnum;
